<template>
    <div class="conBody">
        <div class="accountManage">
            <p class="account_manage_title">我的评论</p>
            <div class="addBtn">
                <span @click="goback()">返回</span>
            </div>
            <div class="tab-contents">
                <div class="nano video_breviary" id="accountSettings">
                    <div class="nano-content" id="home_right_list">

                        <div class="taskDetail">
                            <p class="taskTitle">尼日利亚在普惠金融和手机银行领域已经落后其他非洲国家</p>
                            <p class="taskTime"><span>新华社</span><span>2018-06-07 15:45</span><span>责任编辑：徐海慧</span></p>
                            <div class="taskDes">
                                尼作为一个体量小但作用独特的角色，在当下如火如荼的“一带一路”建设中，如何借势起风，在新的突破中提升自身竞争力? 正在澳门举行的2018“一带一路”与澳门发展国际研讨会，试图为这个问题给出答案:“化愿景为行动”——这也是本次研讨会的主题。
                            </div>
                            <div>新华社澳门6月6日电（记者郭鑫）澳门特别行政区作为一个体量小但作用独特的角色，在当下如火如荼的“一带一路”建设中，如何借势起风，在新的突破中提升自身竞争力? 正在澳门举行的2018“一带一路”与澳门发展国际研讨会，试图为这个问题给出答案:“化愿景为行动”——这也是本次研讨会的主题。讨会吸引了来自内地和港澳，以及澳大利亚、美国、新加坡、泰国等国家和地区的政商侨界领袖、专家学者，就澳门如何发挥自身优势，更好地参与“一带一路”建设出谋划策。 澳门拥有众多归侨人口，在特区经济、贸易、金融等领域拥有国际化的先天优势。此外，中央政府赋予澳门“一个中心、一个平台”的职能，也就是在国家“十三五”规划中明确支持澳门打造“世界旅游休闲中心”和“中国与葡语国家商贸合作服务平台”，更让澳门这个中西文化交融的小城如虎添翼。 “怎么能够采取一个更加绿色、更加生态、更加环保的方式来推动国家建设，推动‘一带一路’建设，澳门是可以扮演重要角色的。”张燕生说，“澳门不但可以跟内地合作来打造这些产业的新增长点，也可以在粤港澳大湾区。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    // import './static/css/accountSettings.css'
    export default {
        name: "myCommentDetail",
        data() {
            return {
                editor: {},
                title: "",
                description: "",
                content: "",
                maskShow:false
            }
        },
        methods: {
            goback() {
                this.$router.push({path: "/accountSettings/myComment"});
            },

        },
        activated() {
            this.content = '';
            this.title = '';
            this.description = '';
            this.maskShow=false;
        },
        mounted() {
            this.load();
        }
    }
</script>

<style scoped>
    .accountManage {
        position: relative;
    }
    .reqiued{
        color: red;
        margin-right:10px
    }
    .tab-contents{
        padding-top:0px
    }
    .tab-contents lable{
        padding-left:0;
        padding-right:0;
    }
    .myBtn.cur{
        background:rgba(242,243,244,.8);
        color:rgba(133,144,166,1);
        margin-left:30px!important;
    }
    .myBtn.cur:hover{
        background:rgba(242,243,244,1);
        cursor:pointer;
    }
    .myBtn:hover{
        background:rgba(32,142,255,1);
        cursor:pointer;
    }
    .myBtn{
        width:140px;
        height:34px;
        background:rgba(32,142,255,.8);
        border-radius:4px;
        font-size:14px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        text-align:center;
        color:rgba(255,255,255,1);
        line-height:34px;
        display:inline-block
    }
    .addBtn {
        position: absolute;
        right: 40px;
        top: 20px;
        width: 60px;
        height: 30px;
        background: rgba(242, 243, 244, 1);
        border-radius: 20px;
        text-align: center;
    }

    .addBtn:hover {
        cursor: pointer;
    }

    .addBtn span {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(133, 144, 166, 1);
        line-height: 30px;
        display: block;
    }
    .taskStatus{
        display:flex;
        justify-content:space-between;
        height:38px;
        background:rgba(254,252,235,1);
        padding:8px 30px
    }
    .statusA{
        padding:0;

    }
    .conBody{
        position:relative;
    }
    .statusA span{
        display: block;
        float:left;
    }
    .statusA span:nth-child(2){
        overflow:hidden;
        height:20px;
        margin-left:10px;
    }
    .Ablock{
        width:53px;
        height:20px;
        background:rgba(69,133,245,1);
        border-radius:10px;
        font-size:12px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(255,255,255,1);
        text-align:center;
    }
    .statusB{
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(69,133,245,1);
        width:70px;
    }
    .statusB:hover{
        cursor:pointer;
    }
    .taskDetail{
        padding:0 30px 30px;
    }
    .taskTitle{
        font-size:20px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        margin-top:20px!important;
        line-height:24px;
    }
    .taskTime{
        height:12px;
        font-size:12px;
        margin-top:20px!important;
        font-family:PingFangSC-Semibold;
        font-weight:600;
        color:rgba(128,130,141,1);
        line-height:12px;
    }
    .taskTime span{
        margin-right:20px;
    }
    .taskDes{
        font-size:15px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        padding:15px;
        color:rgba(84,87,102,1);
        line-height:30px;
        position:relative;
        border:1px  dashed #333;
        margin-top:40px;
        margin-bottom:10px;
    }
    .taskDes:before{
        content:"摘要";
        position:absolute;
        top: -15px;
        width:40px;
        background-color: white;
    }
    .mask{
        position: absolute;
        left: 0px;
        min-height:200px;
        max-height:300px;
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
        border-radius:2px;
        right: 0px;
        bottom: 0px;
        padding:30px 40px;
        top: 0px;
        margin: auto;
        text-align:center;
        z-index:9999;
    }
    .mask p{
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:24px;
        margin-top:20px!important;
    }
    .mask p:nth-child(0){
        font-size:18px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:25px;
    }
    .mask span{
        width:126px;
        height:32px;
        background:rgba(32,142,255,1);
        border-radius:16px;
        display:block;
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(255,255,255,1);
        margin:30px auto 0;
        line-height:32px;
    }
    .mask span:hover{
        cursor: pointer;
    }



</style>
